// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
var setCreatorHandler = function (fn) {
    return function () {
        return $foreign["_setCreatorHandler"](Effect_Uncurried.mkEffectFn1(fn));
    };
};
export {
    setNextModalShouldReplaceHash
} from "./foreign.js";
export {
    setCreatorHandler
};
//# sourceMappingURL=index.js.map
